export const GET_DETAILS_DATA = 'details/GET_DETAILS_DATA';